/* eslint-disable react/style-prop-object */
import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '@honeycomb/ui-core';

export function NetflightsPhoneIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 50 50">
            <path
                d="M12.7,22.6c3.4,6.7,9,12.2,15.7,15.7l5.2-5.2c0.6-0.6,1.6-0.9,2.4-0.6c2.7,0.9,5.5,1.4,8.5,1.4
	c1.3,0,2.4,1.1,2.4,2.4v8.3c0,1.3-1.1,2.4-2.4,2.4C22.2,46.9,4,28.7,4,6.4C4,5.1,5.1,4,6.4,4h8.3c1.3,0,2.4,1.1,2.4,2.4
	c0,3,0.5,5.8,1.4,8.5c0.3,0.8,0.1,1.8-0.6,2.4L12.7,22.6z"
            />
        </SvgIcon>
    );
}
